import Vue from "vue";
import { ActionTree } from "vuex";
import axios from "@/axios-config/default";
import { IRootState } from "@/store/types";
import { IUserProfileState } from ".";
import { UserProfileMutationsNames } from "@/store/modules/user-profile/enums";
import { IUser } from "@/models/user";

export const actions: ActionTree<IUserProfileState, IRootState> = {
    fetchUserInfo({ commit }): void {
        axios
            .get(Vue.prototype.$environmentService.getServicePath("me"))
            .then((response) => {
                commit(UserProfileMutationsNames.SetInfo, response.data);
            })
            .catch((error) => {
                // mutation to storage error
                commit(UserProfileMutationsNames.SetError, error);
            });
    },
    setUserInfoState({ commit }, payload: IUser): void {
        commit(UserProfileMutationsNames.SetInfo, payload);
    },
    resetUserProfileState({ commit }): void {
        commit(UserProfileMutationsNames.ResetState);
    },
};
